module.exports = __webpack_public_path__ + "img/cszq_home_right.0a036cb4.jpeg";